// superUser.js

import { getIdTokenResult } from 'firebase/auth';

// Firebase
import { auth } from 'firebaseConfig';

export function hasSuperUserClaim(claims) {
  return Boolean(claims && claims.superuser === true);
}

export async function getCurrentUserClaims({ forceRefresh = false } = {}) {
  const user = auth.currentUser;
  if (!user) return {};

  const tokenResult = await getIdTokenResult(user, forceRefresh);
  return tokenResult?.claims && typeof tokenResult.claims === 'object'
    ? tokenResult.claims
    : {};
}

export async function isCurrentUserSuperUser(options = {}) {
  const claims = await getCurrentUserClaims(options);
  return hasSuperUserClaim(claims);
}
